__turbopack_context__.v({
  "bottom": "Tooltip-module-scss-module__I2PXca__bottom",
  "fade": "Tooltip-module-scss-module__I2PXca__fade",
  "fade-slide": "Tooltip-module-scss-module__I2PXca__fade-slide",
  "open-from-center": "Tooltip-module-scss-module__I2PXca__open-from-center",
  "right": "Tooltip-module-scss-module__I2PXca__right",
  "spin": "Tooltip-module-scss-module__I2PXca__spin",
  "tooltip": "Tooltip-module-scss-module__I2PXca__tooltip",
  "tooltipBtn": "Tooltip-module-scss-module__I2PXca__tooltipBtn",
  "tooltipContent": "Tooltip-module-scss-module__I2PXca__tooltipContent",
  "tooltipOpen": "Tooltip-module-scss-module__I2PXca__tooltipOpen",
});
